import { Col, Row, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Card, Tag, Tabs } from "antd";
import CardImageItem from "../../Users/component/CardImage";
import {
  formatCriticity,
  formatState,
  getCriticityColor,
  getStateColor,
  mapToAntDColor,
} from "../../../Components/Common/FormatDate/formatStatus";
import SuiviDemande from "./demande/suivi";
import TechnicienDemande from "./demande/technicienDemande";
import IntervenantDemande from "./demande/intervenants";

const { TabPane } = Tabs;

const DetailDemande = ({ modal, toggle, selectedDemande, isLoading, isError, error }) => {
  const {
    id,
    requestNumber,
    level,
    description,
    fileName,
    name,
    createdAt,
    status,
    technician,
    archived,
    address,
    closureDate,
    remiseDate,
    requestFor,
    intervenants,
    suivis,
  } = selectedDemande || {};
  
  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop="static"
      style={{ maxWidth: "1000px" }}
    >
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        <strong>Détail de la demande {requestNumber} de {technician?.name}</strong>
      </ModalHeader>

      <ModalBody style={{ padding: "2rem 3rem", backgroundColor: "#f7f7f7" }}>
        <Row gutter={24}>
          <Col lg={3} className="text-center">
            <Card className="p-2">
              <CardImageItem fileName={fileName} height={180} />

              <div style={{ marginTop: 15 }}>
                <h5 style={{ marginBottom: 5 }}>{name || "-"}</h5>
                <Tag 
                  color={mapToAntDColor(getStateColor(status))} 
                  style={{ fontSize: 13, marginTop: 20}}
                >
                  {formatState(status)}
                </Tag>

                <Tag 
                  color={mapToAntDColor(getCriticityColor(level))} 
                  style={{ fontSize: 13, marginTop: 20}}
                >
                  Criticité : {formatCriticity(level)}
                </Tag>

              </div>
            </Card>
          </Col>

          <Col lg={9}>
            <Card>
              <Tabs defaultActiveKey="1">
                <TabPane tab="Suivi" key="1">
                  <SuiviDemande selectedDemande={selectedDemande} />
                </TabPane>

                <TabPane tab="Technicien" key="2">
                  <TechnicienDemande technicien={technician} />
                </TabPane>

                <TabPane tab="Intervenant" key="3">
                  <IntervenantDemande
                    intervenants={intervenants}
                    isLoading={isLoading}
                    isError={isError}
                    error={error}
                  />
                </TabPane>
              </Tabs>
            </Card>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default DetailDemande;
